<template>
  <div class="vmp-sign-live" v-if="!auth_gd">
    <!-- 签到设置(创建)对话框 -->
    <vh-dialog
      :title="$t('host.k_596001')"
      :visible.sync="signVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <signinSet v-if="signVisible" @start="startSign" @viewList="handleViewRecord"></signinSet>
    </vh-dialog>

    <!-- 签到倒计时/签到结果共用对话框 -->
    <div class="vmp-sign-live_down" v-if="signinDown">
      <div class="down-container">
        <!-- 签到倒计时内容 -->
        <Counter
          v-if="showCounter"
          ref="counter"
          :pushType="doingSign.push_type"
          :autoSign="doingSign.is_auto_sign == 1"
          :title="doingSign.sign_tips"
          :total="total"
          :remaining="remaining"
          @close-sign="closeAutoSignin"
          @viewList="handleViewRecord"
          @toSignCreate="handleToCreate"
        ></Counter>

        <!-- 签到结果 -->
        <signinResult
          v-if="showResult"
          @restartsign="restartSign"
          :room_id="roomId"
          :signId="doingSign.id"
        ></signinResult>

        <!-- 定时签到已设置信息展示板 -->
        <TimerSignBoard
          v-if="showTimerSignBoard"
          :notPushedTimes="notPushedTimes"
          @viewList="handleViewRecord"
          @toSignCreate="handleToCreate"
        ></TimerSignBoard>

        <!-- 底部关闭按钮 -->
        <div class="vmp-sign-live_close" @click="signinDown = false">
          <i class="vh-iconfont vh-line-circle-close"></i>
        </div>
      </div>
    </div>

    <SignList
      :signId="doingSign?.id"
      :reuse="doingSign?.is_auto_sign == 0"
      :remaining="remaining"
      :visible.sync="signListVisible"
    ></SignList>
  </div>
</template>
<script>
  import mainMixin from './mixins/main.js';
  export default {
    name: 'VmpSignLive',
    mixins: [mainMixin],
    computed: {
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      }
    }
  };
</script>
<style lang="less">
  .vmp-sign-live {
    &_down {
      position: fixed;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      z-index: 128;
      .down-container {
        height: 469px;
        width: 400px;
        margin-top: 15vh;
        background-image: url('./img/signBox@2x.png');
        background-size: 100% 100%;
        position: relative;
      }
    }
    &_close {
      position: absolute;
      left: 47%;
      bottom: -18px;
      cursor: pointer;
      border-radius: 50%;
      i {
        font-size: 24px;
        color: #fff;
      }
    }
  }
</style>
